var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#EF9C50",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3535 30H29.0634C30.8743 30 32.0032 28.0362 31.0977 26.4721L22.2428 11.173C21.3373 9.609 19.0795 9.609 18.174 11.173L9.31912 26.4721C8.41364 28.0362 9.54255 30 11.3535 30ZM20.2084 21.7683C19.5617 21.7683 19.0325 21.2392 19.0325 20.5924V18.2405C19.0325 17.5937 19.5617 17.0645 20.2084 17.0645C20.8552 17.0645 21.3844 17.5937 21.3844 18.2405V20.5924C21.3844 21.2392 20.8552 21.7683 20.2084 21.7683ZM21.3844 26.4721H19.0325V24.1202H21.3844V26.4721Z",
    fill: "#EF9C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.317b1db67f5af5207ca21673fc89da65.svg";
export { ForwardRef as ReactComponent };